import { API_VERSIONS } from "../utils/constants";
import RequestHandler from "./RequestHandler";

function UnitsAPI() {
    const baseUnitsAPI = "units";

    async function listUnits(
        itemsPerPage,
        filters,
        offset = 0,
        defaultSortBy = null,
        defaultSortDirection = null
    ) {
        try {
            const skip = offset * itemsPerPage;
            const sortBy = defaultSortBy || "createdAt";
            const sortDirection = defaultSortDirection || "ASC";
            let URL = `${API_VERSIONS.v1}/${baseUnitsAPI}/list?skip=${skip}&take=${itemsPerPage}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
            const result = await RequestHandler.post(URL, filters);
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function addUnit(payload) {
        try {
            const result = await RequestHandler.post(
                `${API_VERSIONS.v1}/${baseUnitsAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    async function updateUnit(payload) {
        try {
            const result = await RequestHandler.put(
                `${API_VERSIONS.v1}/${baseUnitsAPI}`,
                payload
            );
            return result || {};
        } catch (error) {
            console.log(error);
        }
    }

    return {
        listUnits,
        addUnit,
        updateUnit,
    };
}

export default UnitsAPI();
